import {ChangeDetectionStrategy, Component} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {combineLatest, defaultIfEmpty, Observable} from 'rxjs';
import {map, take, takeUntil} from 'rxjs/operators';
import * as cartActions from '../../common/shopping-cart/cart.actions';
import * as eventActions from '../../common/event-emitter/event.actions';
import {OnDestroySubject} from '../../data/model';
import {selectUrl} from '../../router.selectors';
import {selectCheckEmptyCart} from '../../common/shopping-cart/cart.selectors';
import {Router} from '@angular/router';
import {EventEmitterService} from 'src/app/common/event-emitter/event-emitter.service';

@Component({
  selector: 'app-no-addons',
  templateUrl: './no-addons.component.html',
  styleUrls: ['./no-addons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {class: 'app-no-addons'},
  standalone: false,
})
export class NoAddonsComponent extends OnDestroySubject {
  isErrorPage$: Observable<boolean>;
  cartIsEmpty$: Observable<boolean>;

  constructor(
    private store: Store,
    private router: Router,
    private eventEmitterService: EventEmitterService,
  ) {
    super();
    this.isErrorPage$ = this.store.pipe(
      select(selectUrl),
      map(url => url?.includes('commerceElement:error')),
      takeUntil(this.onDestroy),
    );
    this.cartIsEmpty$ = this.store.pipe(
      select(selectCheckEmptyCart),
      defaultIfEmpty(true),
      takeUntil(this.onDestroy),
    );
    combineLatest([this.isErrorPage$])
      .pipe(takeUntil(this.onDestroy))
      .subscribe(([isErrorPage]) => {
        if (isErrorPage) {
          this.eventEmitterService.navigation({
            totalPages: 1,
            currentPage: 1,
            currentRoute: '/error',
          });
        } else {
          this.eventEmitterService.navigation({
            totalPages: 1,
            currentPage: 1,
            currentRoute: '/no-add-ons',
          });
        }
      });
  }

  checkout(): void {
    combineLatest([this.isErrorPage$, this.cartIsEmpty$])
      .pipe(take(1))
      .subscribe(([isErrorPage, cartIsEmpty]) => {
        if (isErrorPage && cartIsEmpty) {
          this.store.dispatch(eventActions.continueToCheckout());
        } else if (!cartIsEmpty) {
          this.router.navigate([
            {outlets: {commerceElement: 'commerce/address'}},
          ]);
        } else {
          this.store.dispatch(cartActions.completeOrder());
        }
      });
  }

  registerAnother(): void {
    this.isErrorPage$.pipe(take(1)).subscribe(isErrorPage => {
      if (isErrorPage) {
        this.store.dispatch(eventActions.registerAnother());
      } else {
        this.store.dispatch(cartActions.registerAnotherPerson());
      }
    });
  }
}
